<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width="16"
    height="16"
  >
    <path
      d="M9.36219 2.73089C9.46148 2.68972 9.57036 2.66699 9.68454 2.66699C9.79872 2.66699 9.90759 2.68972 10.0069 2.73089C10.1062 2.77198 10.1993 2.8329 10.28 2.91364L13.087 5.72066C13.4159 6.04952 13.4159 6.58271 13.087 6.91157C12.7581 7.24044 12.225 7.24044 11.8961 6.91157L10.5266 5.54212V10.2459C10.5266 11.0649 10.2013 11.8502 9.62227 12.4293C9.04321 13.0083 8.25784 13.3337 7.43892 13.3337L3.5091 13.3337C3.04402 13.3337 2.66699 12.9566 2.66699 12.4916C2.66699 12.0265 3.04402 11.6494 3.5091 11.6494H7.43892C7.81115 11.6494 8.16814 11.5016 8.43135 11.2384C8.69456 10.9752 8.84243 10.6182 8.84243 10.2459L8.84243 5.54212L7.47298 6.91157C7.14411 7.24044 6.61092 7.24044 6.28206 6.91157C5.9532 6.58271 5.9532 6.04952 6.28206 5.72066L9.08908 2.91364C9.16982 2.8329 9.26287 2.77198 9.36219 2.73089Z"
    />
  </svg>
</template>
